<div class="w-full h-full">
<app-tool-loader [isLoading]="isLoading()" positionUnset="true">
  <p-toolbar>
    <ng-template #start>
      <div class="flex items-center space-x-2 toolbar-menu">
        <p-select
          [(ngModel)]="selectedSingleMultiple"
          [options]="singleMultiple"
          (onChange)="modeToggle($event.value)"
          appendTo="body"
        ></p-select>

        <p-selectButton
          [options]="resultsDisplay"
          [(ngModel)]="selectedResultsDisplay"
          (onChange)="onSelectedResultsDisplayUpdated($event)"
          [allowEmpty]="false"
        ></p-selectButton>

        @if (selectedResultsDisplay === 'grid') {
          <div>
            <p-checkbox
              size="small"
              binary="true"
              [(ngModel)]="showHeatmap"
              (change)="toggleHeatmap($event)"
              inputId="showHeatmap"
            ></p-checkbox>
            <label class="ml-2" for="showHeatmap">Heatmap</label>
          </div>
        }

        @if (selectedResultsDisplay === 'plot' || selectedResultsDisplay === 'heatmap') {
          <p-selectButton
            [options]="depthView"
            [(ngModel)]="selectedDepthView"
            (onChange)="depthViewToggle($event)"
            [allowEmpty]="false"
          ></p-selectButton>
        }
      </div>
    </ng-template>

    <ng-template #center>
      <div class="flex gap-2 items-center jusitfy-end content-end">
        @if (selectedSingleMultiple === 'singleOperation') {
          <p-checkbox
            size="small"
            (onChange)="syncPressAndTemp($event)"
            [(ngModel)]="syncThermalResults"
            pTooltip="Sync P&T results"
            binary="true"
          ></p-checkbox>
        }
        @if (selectedSingleMultiple === 'singleOperation') {
          <p-select
            [options]="operationsWithNone"
            optionLabel="name"
            [(ngModel)]="selectedOperation"
            (onChange)="onOperationSelected($event, true)"
            appendTo="body"
            class="w-[300px]"
          ></p-select>
        }

      @if (selectedSingleMultiple ==='operationType') {
        <p-select
          [options]="operationTypes"
          (onChange)="onOperationTypeSelected($event.value)"
          [(ngModel)]="selectedOperationType"
          appendTo="body"
        ></p-select>
      }

        @if (selectedSingleMultiple === 'multipleOperation' || selectedSingleMultiple === 'operationType') {
          <app-units-select-input
            class="w-[200px]"
            [options]="annulusNames"
            optionLabel="label"
            dataKey="value"
            [optionLabelFormatter]="formatAnnulusOption"
            [unit]="shortLengthUnit"
            (onChange)="annulusDropdownChange($event)"
            [(ngModel)]="selectedAnnulus"
            [readOnly]="selectedSingleMultiple === 'operationType'"
            ariaLabel="Temperature result location"
            appendTo="body"
          ></app-units-select-input>
        }

        <p-button
          outlined="true"
          size="small"
          [disabled]="moveUpDisabled"
          icon="pi pi-arrow-up"
          (onClick)="onUpDownButtonClick('up', true)"
        ></p-button>
        <p-button
          outlined="true"
          size="small"
          [disabled]="moveDownDisabled"
          icon="pi pi-arrow-down"
          (onClick)="onUpDownButtonClick('down', true)"
        ></p-button>

        @if (phases?.length > 1 && selectedSingleMultiple === 'singleOperation') {
          <p-select
            class="ml-2"
            [options]="phases"
            [ngModel]="selectedPhase"
            (onChange)="onPhaseSelected($event, true)"
            optionLabel="phaseNumber"
            appendTo="body"
          >
            <ng-template pTemplate="selectedItem">
              Phase {{ selectedPhase?.phaseNumber }}
            </ng-template>
            <ng-template let-phase pTemplate="item">
              Phase {{ phase.phaseNumber }}
            </ng-template>
          </p-select>
        }
      </div>
    </ng-template>

    <ng-template #end>
      @if (selectedSingleMultiple === 'singleOperation') {
      <div class="flex space-x-2 pr-2">
        <div>
          <p-checkbox
            size="small"
            [(ngModel)]="showWellborePoints"
            (onChange)="toggleWellborePoints($event)"
            binary="true"
            inputId="showWellborePoints"
          ></p-checkbox>
          <label class="ml-2" for="showWellborePoints">Wellbore</label>
        </div>

        <div class="mr-2">
          <p-checkbox
            size="small"
            [(ngModel)]="showFormationPoints"
            (onChange)="toggleFormationPoints($event)"
            binary="true"
            inputId="showFormationPoints"
          ></p-checkbox>
          <label class="ml-2" for="showFormationPoints">Formation</label>
        </div>
      </div>
      }
    </ng-template>
  </p-toolbar>

  <div class="flex-1 min-h-0 overflow-hidden" [hidden]="selectedResultsDisplay !== 'grid'">
    <app-perical-results-grid
      tableName="Thermal Results - Temperatures"
      [tableData]="resultsGrid"
      [columnDefinitions]="
        selectedSingleMultiple === 'singleOperation'
          ? cols
          : operationNames
      "
      [selectedOperation]="selectedOperation"
      [minTemp]="minTemp"
      [maxTemp]="maxTemp"
      [showHeatmap]="showHeatmap"
      [virtualScroll]="true"
    />
  </div>

  @if (selectedResultsDisplay === 'plot') {
    <app-thermal-results-plot
      class="flex-1 min-h-0"
      xAxisTitle="Temperature ({{ temperatureUnit }})"
      depthUnit="{{ depthUnit }}"
      [temperatureUnit]="temperatureUnit"
      [diameterUnit]="diameterUnit"
      [plotTitle]="'Thermal Results - Temperatures'"
      [plotData]="
        selectedSingleMultiple === 'singleOperation'
          ? results
          : multipleResultsFull
      "
      [columnDefinitions]="
        selectedSingleMultiple === 'singleOperation'
          ? cols
          : operationNames
      "
      [selectedDepthDisplay]="selectedDepthView"
      [plotName]="plotName"
      [tubulars]="tubulars"
      [selectedAnnulus]="annulusName"
      [downloadPlotName]="
        selectedSingleMultiple === 'singleOperation'
          ? 'single_operation_plot'
          : 'multiple_operation_plot'
      "
      [thermalResultsStore]="temperatureResultsStore"
    ></app-thermal-results-plot>
  }

  @if (selectedResultsDisplay === 'heatmap') {
    <app-heatmap
      class="mt-2 flex-1 min-h-0"
      [depthUnit]="depthUnit"
      [heatGridHeaders]="
        selectedSingleMultiple === 'singleOperation'
          ? cols
          : operationNames
      "
      [heatGrid]="
        selectedSingleMultiple === 'singleOperation'
          ? results
          : multipleResultsFull
      "
      [useTvd]="selectedDepthView === 'tvd'"
      [plotTitle]="'Thermal Results - Temperatures'"
      [plotName]="plotName"
      [heatmapStore]="temperatureResultsStore"
    ></app-heatmap>
  }

</app-tool-loader>
</div>

<p-dialog [draggable]="false" [(visible)]="missingOperations" [closable]="false" appendTo="self">
  <i class="pi pi-exclamation-circle pr-1"></i>
  <label> No Operations Exist: Please specify at least one operation to view results.</label>
  <br />
  <br />
</p-dialog>

<p-dialog [draggable]="false" [(visible)]="needToCalculate" [closable]="false" appendTo="self">
  <i class="pi pi-exclamation-circle pr-1"></i>
  <label>{{ calculationError }}</label>
  <br />
  <br />
</p-dialog>
